import {MutationTree} from 'vuex';
import { MRState } from '@/store/types';
import { MR } from './MR';

export const mutations: MutationTree<MRState> = {
    MRLoaded(state, payload: MR) {

    }
};